export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_AUDIT_DATA = 'GET_AUDIT_DATA'
